import { section, align } from '@settings/common';
import { color } from '@settings/common/color';

export const Schema = () => {
  return {
    category: 'Embed',
    label: 'Embed Content',
    key: 'embed-content',
    fields: [
      {
        label: 'Enable If',
        name: 'state',
        component: 'radio-group',
        direction: 'horizontal',
        variant: 'radio',
        options: [
          {
            value: 'guest',
            label: 'Signed Out',
          },
          {
            value: 'user',
            label: 'Signed In',
          },
          {
            value: 'enable',
            label: 'Always',
          },
        ],
      },
      {
        label: 'Heading',
        name: 'heading',
        component: 'text',
      },
      {
        label: 'Heading Color',
        name: 'headingColor',
        component: 'select',
        options: color.options,
        defaultValue: '#574F4C',
      },
      {
        label: 'SubHeading',
        name: 'subHeading',
        component: 'text',
      },
      {
        name: 'snippet',
        label: 'Embed Code',
        component: 'html',
        description: 'Paste in snippet we want to display',
      },
      {
        label: 'Content alignment (mobile)',
        name: 'alignment',
        component: 'radio-group',
        direction: 'horizontal',
        variant: 'radio',
        options: align.options,
      },
      {
        label: 'Content alignment (desktop)',
        name: 'alignmentDt',
        component: 'radio-group',
        direction: 'horizontal',
        variant: 'radio',
        options: align.options,
      },
      {
        ...section,
        defaultValue: {
          desktop: {
            container: 'container',
            mt: 'none',
            py: 'none',
          },
          mobile: {
            container: 'content',
            mt: 'none',
            py: 'none',
          },
        },
      },
    ],
    defaultValue: {
      state: 'enable',
      alignment: align.value.center,
      alignmentDt: align.value.center,
    },
  };
};
